export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9596.40ff39cc.jpg";